import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import icons from './shared/Icons';

const DemoModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    // lock scroll and preserve layout by compensating for scrollbar width
    const previousOverflow = document.body.style.overflow;
    const previousPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    };
  }, [isOpen]);

  return (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        className="fixed inset-0 z-[100] flex items-center justify-center p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />
        <motion.div
          className="relative glass-card rounded-2xl p-8 max-w-lg w-full"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ type: 'spring', damping: 25 }}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            aria-label="Close modal"
          >
            {icons.close}
          </button>
          <div className="text-center">
            <div className="w-16 h-16 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-4">
              <span className="text-primary">{icons.play}</span>
            </div>
            <h3 className="text-2xl font-bold mb-2">Request a Live Demo</h3>
            <p className="text-gray-400 mb-6">See OpticVance in action with your own data.</p>
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); onClose(); }}>
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 bg-dark-card border border-dark-border rounded-lg text-white placeholder-gray-500 focus:border-primary focus:outline-none transition-colors"
                aria-label="Your name"
                required
              />
              <input
                type="email"
                placeholder="Work Email"
                className="w-full px-4 py-3 bg-dark-card border border-dark-border rounded-lg text-white placeholder-gray-500 focus:border-primary focus:outline-none transition-colors"
                aria-label="Work email"
                required
              />
              <select
                className="w-full px-4 py-3 bg-dark-card border border-dark-border rounded-lg text-gray-400 focus:border-primary focus:outline-none transition-colors"
                aria-label="Company size"
                defaultValue=""
              >
                <option value="" disabled>Company Size</option>
                <option>1-50 employees</option>
                <option>51-200 employees</option>
                <option>201-1000 employees</option>
                <option>1000+ employees</option>
              </select>
              <button
                type="submit"
                className="w-full py-3 bg-primary hover:bg-secondary text-black font-semibold rounded-lg transition-all duration-300 glow-btn"
              >
                Schedule Demo
              </button>
            </form>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
  );
};

export default DemoModal;
